function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:current}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_315",
  d: "M5.414 1.172a3 3 0 1 1-4.243 0 3 3 0 0 1 4.243 0",
  className: "cls-1",
  transform: "translate(4.707 4.707)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_316",
  d: "M11.5 0h-7A4.5 4.5 0 0 0 0 4.5v7A4.5 4.5 0 0 0 4.5 16h7a4.5 4.5 0 0 0 4.5-4.5v-7A4.5 4.5 0 0 0 11.5 0zM8 12a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm4.5-8a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5z",
  className: "cls-1"
});

function SvgInstagramColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "instagram",
    width: "current",
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColor);
export default __webpack_public_path__ + "static/media/Instagram-color.ddc93c1e.svg";
export { ForwardRef as ReactComponent };